import { render, staticRenderFns } from "./Clicker.vue?vue&type=template&id=e8c9c608&scoped=true&"
import script from "./Clicker.vue?vue&type=script&lang=js&"
export * from "./Clicker.vue?vue&type=script&lang=js&"
import style0 from "./Clicker.vue?vue&type=style&index=0&id=e8c9c608&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c9c608",
  null
  
)

export default component.exports